export const SUBSCRIBE_VEHICLE = 'subscribeVehicle';
export const UNSUBSCRIBE_VEHICLE = 'unsubscribeVehicle';
export const CLEAR_SUBSCRIBE_VEHICLE = 'clearSubscriptionVehicle';
export const SET_MEDIA_DIALOG = 'setMediaDialog';
export const SET_EVENT_DIALOG = 'setEventDialog';


const subscribeVehicle = (state, payload) => {
    state.subscribedVehicle = payload
};

const unsubscribeVehicle = (state, payload) => {
    state.subscribedVehicle = null
};

const clearSubscriptionVehicle = (state, payload) => {
    state.subscribedVehicle = null
};

const setMediaDialog = (state, payload) => {
    state.mediaDialog = payload
};

const setEventDialog = (state, payload) => {
    state.eventDialog = payload
};


export default {
    subscribeVehicle,
    unsubscribeVehicle,
    clearSubscriptionVehicle,
    setMediaDialog,
    setEventDialog
};
